export default __webpack_public_path__ + "static/footer-top-0eea79a353e0e1eee2dc8ee691d0d004.svg";